export default __webpack_public_path__ + "static/icon-66f577a319d7d23897fc4951c9b9d58c.png";